import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateBanner } from "../../../RTK/categories/BannerSlice";
import { X, Loader2, Image as ImageIcon } from "lucide-react";

const EditBannerPopup = ({ isVisible, banner, onClose }) => {
  const dispatch = useDispatch();
  const { isUpdating } = useSelector((state) => state.banners);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
    is_active: true,
  });
  const [imagePreview, setImagePreview] = useState("");

  useEffect(() => {
    if (banner) {
      setFormData({
        title: banner.title || "",
        description: banner.description || "",
        is_active: banner.is_active,
        image: null,
      });
      setImagePreview(banner.image || "");
    }
  }, [banner]);

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({ ...prev, [name]: file }));
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append("title", formData.title);
    form.append("description", formData.description);
    form.append("is_active", formData.is_active);
    if (formData.image) {
      form.append("image", formData.image);
    }

    const result = await dispatch(updateBanner({ id: banner.id, data: form }));
    if (!result.error) {
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80"
      dir="rtl"
    >
      <div className="relative bg-gray-900 rounded-xl w-full max-w-2xl overflow-hidden border border-gray-800">
        <button
          onClick={onClose}
          className="absolute top-4 left-4 p-2 rounded-lg bg-gray-800/50 hover:bg-gray-700/50 transition-colors"
        >
          <X className="w-5 h-5 text-gray-400" />
        </button>

        <form onSubmit={handleSubmit} className="p-6">
          <h2 className="text-2xl font-bold text-white mb-6">تعديل البانر</h2>

          <div className="space-y-6">
            {/* Image Upload */}
            <div>
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-700 border-dashed rounded-lg relative">
                <div className="space-y-1 text-center">
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Banner preview"
                      className="mx-auto h-48 w-full object-cover rounded-lg"
                    />
                  ) : (
                    <div className="flex flex-col items-center">
                      <ImageIcon className="w-12 h-12 text-gray-400" />
                      <p className="text-gray-500">اضغط لاختيار صورة</p>
                    </div>
                  )}
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleInputChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />
                </div>
              </div>
            </div>

            {/* Title */}
            <div>
              <input
                placeholder="عنوان البانر"
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="w-full bg-gray-800 text-white px-4 py-2.5 rounded-lg border border-gray-700 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
                required
              />
            </div>

            {/* Description */}
            <div>
              <textarea
                placeholder="وصف البانر"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="3"
                className="w-full bg-gray-800 text-white px-4 py-2.5 rounded-lg border border-gray-700 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
              />
            </div>

            {/* Active Status */}
            <div className="flex items-center">
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleInputChange}
                className="h-4 w-4 text-yellow-500 focus:ring-yellow-500 border-gray-700 rounded"
              />
              <label className="mr-2 text-sm text-gray-300">تفعيل البانر</label>
            </div>
          </div>

          {/* Submit Button */}
          <div className="mt-6">
            <button
              type="submit"
              disabled={isUpdating}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-yellow-500 text-black rounded-lg hover:bg-yellow-600 transition-colors font-medium"
            >
              {isUpdating ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span>جاري الحفظ...</span>
                </>
              ) : (
                <span>حفظ التغييرات</span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBannerPopup;
